import _construct from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/construct.js";
import _toConsumableArray from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _classCallCheck from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/doctocat/doctocat/node_modules/@babel/runtime/helpers/esm/createClass.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
import DurationFormat from './duration-format-ponyfill.js';
var durationRe = /^[-+]?P(?:(\d+)Y)?(?:(\d+)M)?(?:(\d+)W)?(?:(\d+)D)?(?:T(?:(\d+)H)?(?:(\d+)M)?(?:(\d+)S)?)?$/;
export var unitNames = ['year', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
export var isDuration = function isDuration(str) {
  return durationRe.test(str);
};
export var Duration = /*#__PURE__*/function () {
  function Duration() {
    var years = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    var months = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var weeks = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    var days = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var hours = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
    var minutes = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
    var seconds = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
    var milliseconds = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
    _classCallCheck(this, Duration);
    this.years = years;
    this.months = months;
    this.weeks = weeks;
    this.days = days;
    this.hours = hours;
    this.minutes = minutes;
    this.seconds = seconds;
    this.milliseconds = milliseconds;
    this.years || (this.years = 0);
    this.sign || (this.sign = Math.sign(this.years));
    this.months || (this.months = 0);
    this.sign || (this.sign = Math.sign(this.months));
    this.weeks || (this.weeks = 0);
    this.sign || (this.sign = Math.sign(this.weeks));
    this.days || (this.days = 0);
    this.sign || (this.sign = Math.sign(this.days));
    this.hours || (this.hours = 0);
    this.sign || (this.sign = Math.sign(this.hours));
    this.minutes || (this.minutes = 0);
    this.sign || (this.sign = Math.sign(this.minutes));
    this.seconds || (this.seconds = 0);
    this.sign || (this.sign = Math.sign(this.seconds));
    this.milliseconds || (this.milliseconds = 0);
    this.sign || (this.sign = Math.sign(this.milliseconds));
    this.blank = this.sign === 0;
  }
  _createClass(Duration, [{
    key: "abs",
    value: function abs() {
      return new Duration(Math.abs(this.years), Math.abs(this.months), Math.abs(this.weeks), Math.abs(this.days), Math.abs(this.hours), Math.abs(this.minutes), Math.abs(this.seconds), Math.abs(this.milliseconds));
    }
  }, {
    key: "toLocaleString",
    value: function toLocaleString(locale, opts) {
      return new DurationFormat(locale, opts).format(this);
    }
  }], [{
    key: "from",
    value: function from(durationLike) {
      var _a;
      if (typeof durationLike === 'string') {
        var str = String(durationLike).trim();
        var factor = str.startsWith('-') ? -1 : 1;
        var parsed = (_a = str.match(durationRe)) === null || _a === void 0 ? void 0 : _a.slice(1).map(function (x) {
          return (Number(x) || 0) * factor;
        });
        if (!parsed) return new Duration();
        return _construct(Duration, _toConsumableArray(parsed));
      } else if (typeof durationLike === 'object') {
        var years = durationLike.years,
          months = durationLike.months,
          weeks = durationLike.weeks,
          days = durationLike.days,
          hours = durationLike.hours,
          minutes = durationLike.minutes,
          seconds = durationLike.seconds,
          milliseconds = durationLike.milliseconds;
        return new Duration(years, months, weeks, days, hours, minutes, seconds, milliseconds);
      }
      throw new RangeError('invalid duration');
    }
  }, {
    key: "compare",
    value: function compare(one, two) {
      var now = Date.now();
      var oneApplied = Math.abs(applyDuration(now, Duration.from(one)).getTime() - now);
      var twoApplied = Math.abs(applyDuration(now, Duration.from(two)).getTime() - now);
      return oneApplied > twoApplied ? -1 : oneApplied < twoApplied ? 1 : 0;
    }
  }]);
  return Duration;
}();
export function applyDuration(date, duration) {
  var r = new Date(date);
  r.setFullYear(r.getFullYear() + duration.years);
  r.setMonth(r.getMonth() + duration.months);
  r.setDate(r.getDate() + duration.weeks * 7 + duration.days);
  r.setHours(r.getHours() + duration.hours);
  r.setMinutes(r.getMinutes() + duration.minutes);
  r.setSeconds(r.getSeconds() + duration.seconds);
  return r;
}
export function elapsedTime(date) {
  var precision = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'second';
  var now = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Date.now();
  var delta = date.getTime() - now;
  if (delta === 0) return new Duration();
  var sign = Math.sign(delta);
  var ms = Math.abs(delta);
  var sec = Math.floor(ms / 1000);
  var min = Math.floor(sec / 60);
  var hr = Math.floor(min / 60);
  var day = Math.floor(hr / 24);
  var month = Math.floor(day / 30);
  var year = Math.floor(month / 12);
  var i = unitNames.indexOf(precision) || unitNames.length;
  return new Duration(i >= 0 ? year * sign : 0, i >= 1 ? (month - year * 12) * sign : 0, 0, i >= 3 ? (day - month * 30) * sign : 0, i >= 4 ? (hr - day * 24) * sign : 0, i >= 5 ? (min - hr * 60) * sign : 0, i >= 6 ? (sec - min * 60) * sign : 0, i >= 7 ? (ms - sec * 1000) * sign : 0);
}
export function roundToSingleUnit(duration) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$relativeTo = _ref.relativeTo,
    relativeTo = _ref$relativeTo === void 0 ? Date.now() : _ref$relativeTo;
  relativeTo = new Date(relativeTo);
  if (duration.blank) return duration;
  var sign = duration.sign;
  var years = Math.abs(duration.years);
  var months = Math.abs(duration.months);
  var weeks = Math.abs(duration.weeks);
  var days = Math.abs(duration.days);
  var hours = Math.abs(duration.hours);
  var minutes = Math.abs(duration.minutes);
  var seconds = Math.abs(duration.seconds);
  var milliseconds = Math.abs(duration.milliseconds);
  if (milliseconds >= 900) seconds += Math.round(milliseconds / 1000);
  if (seconds || minutes || hours || days || weeks || months || years) {
    milliseconds = 0;
  }
  if (seconds >= 55) minutes += Math.round(seconds / 60);
  if (minutes || hours || days || weeks || months || years) seconds = 0;
  if (minutes >= 55) hours += Math.round(minutes / 60);
  if (hours || days || weeks || months || years) minutes = 0;
  if (days && hours >= 12) days += Math.round(hours / 24);
  if (!days && hours >= 21) days += Math.round(hours / 24);
  if (days || weeks || months || years) hours = 0;
  var currentYear = relativeTo.getFullYear();
  var currentMonth = relativeTo.getMonth();
  var currentDate = relativeTo.getDate();
  if (days >= 27 || years + months && days) {
    relativeTo.setDate(currentDate + days * sign);
    months += Math.abs(relativeTo.getFullYear() >= currentYear ? relativeTo.getMonth() - currentMonth : relativeTo.getMonth() - currentMonth - 12);
    if (months) {
      days = 0;
    }
    currentMonth = relativeTo.getMonth();
  }
  if (days >= 6) weeks += Math.round(days / 7);
  if (weeks || months || years) days = 0;
  if (weeks >= 4) months += Math.round(weeks / 4);
  if (months || years) weeks = 0;
  if (months >= 11 || years && months) {
    relativeTo.setMonth(relativeTo.getMonth() + months * sign);
    years += Math.abs(currentYear - relativeTo.getFullYear());
  }
  if (years) months = 0;
  return new Duration(years * sign, months * sign, weeks * sign, days * sign, hours * sign, minutes * sign, seconds * sign, milliseconds * sign);
}
export function getRelativeTimeUnit(duration, opts) {
  var rounded = roundToSingleUnit(duration, opts);
  if (rounded.blank) return [0, 'second'];
  var _iterator = _createForOfIteratorHelper(unitNames),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var unit = _step.value;
      if (unit === 'millisecond') continue;
      var val = rounded["".concat(unit, "s")];
      if (val) return [val, unit];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return [0, 'second'];
}